import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
import { checkoutUrl, faqs } from '../data/landing';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-14 sm:py-20" data-id="element-13" data-mp="249g41vst4gtq">
      <Reveal data-id="element-14" data-mp="249zmreqa798t">
        <SectionHeading title="Preguntas frecuentes" data-id="element-15" data-mp="24bao77w984wr" />
      </Reveal>

      <div className="mx-auto mt-8 max-w-2xl divide-y divide-sage-light rounded-3xl border border-sage-light bg-white px-5 shadow-soft sm:px-7" data-id="element-16" data-mp="289hxxisaw5yg">
        {faqs.map((faq, i) => {
        const isOpen = open === i;
        return <div key={faq.question} data-id="element-17" data-mp="1zgmw6z21ksdf" data-mpi={i}>
              <h3 data-id="element-18" data-mp="2n8btyuxmu91r">
                <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left font-sans text-base font-semibold text-forest focus:outline-none focus-visible:text-forest-soft" data-id="element-19" data-mp="2n7sgprixg8u2">
                  {faq.question}
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-forest text-cream' : 'bg-sage-pale text-forest'}`} data-id="element-20" data-mp="10vjmzzmogr0h">
                    <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="1oj18jdfcmsv0" />
                  </span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-22" data-mp="1jjew367chgn9">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-23" data-mp="1xjple4t0an6b">
                    <p className="pb-5 pr-8 text-[15px] leading-relaxed text-ink-muted" data-id="element-24" data-mp="1y9mpt5pe88b6">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <Reveal className="mx-auto mt-12 max-w-2xl text-center" data-id="element-25" data-mp="285pscco5q8yn">
        <CtaButton href={checkoutUrl} data-id="element-26" data-mp="2c94jnzhjqbre">Quiero acceder a El Escudo de Mamá</CtaButton>
        <p className="mt-3 text-sm font-medium text-ink-muted" data-id="element-27" data-mp="2h88pqh96btdi">
          Solo $17 USD · Pago único · Garantía de 7 días
        </p>
      </Reveal>
    </section>;
}